import { PayloadAction } from '@reduxjs/toolkit';

import { AppState } from 'editor/src/store/app/types';
import { SlotLayoutDraft } from 'editor/src/store/design/types';

const updateSlotLayoutDraftReducer = (state: AppState, { payload }: PayloadAction<Partial<SlotLayoutDraft>>) => {
  if (state.slotLayoutBuilder) {
    state.slotLayoutBuilder.draft = { ...state.slotLayoutBuilder.draft, ...payload };
  }
};

export default updateSlotLayoutDraftReducer;
